import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from '@comparethemarketau/manor-card';
import { Typography } from '@comparethemarketau/manor-typography';
import { Button } from '@comparethemarketau/manor-button';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { getPathWithQueryString, pageContext } from 'ctm-util-functions';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { Separator } from '@comparethemarketau/manor-separator';

const useStyles = createUseStyles((theme) => ({
    quoteCardContainer: {
        boxShadow: theme.elevation.lvl2,
        border: 'none',
        padding: theme.spacing[16],
        flexDirection: 'column',
        marginLeft: 0,
        marginRight: 0
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    titleText: {
        fontWeight: theme.fontWeight.semibold,
        fontSize: theme.fontSize.base,
        lineHeight: '2.3rem'
    },
    titleAction: {
        marginRight: theme.spacing[8]
    },
    contentContainer: {
        marginTop: '2.1rem'
    },
    separator: {
        borderBottom: '1px solid rgba(0,0,0,0.15)'
    }
}));

const _QuoteCard = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { title, children, path, onEditClick, showPleaseWait } = props;

    const handleClick = () => {
        if (onEditClick) {
            onEditClick();
        }
        pageContext.getProps().browserHistory.push(getPathWithQueryString(`/car-insurance/journey/${path}`));
        showPleaseWait(true);
    };

    return (
        <Card className={classes.quoteCardContainer}>
            <div className={classes.titleContainer}>
                <Typography className={classes.titleText}>{title}</Typography>
                <div className={classes.titleAction}>
                    <Button
                        id={`quote-card-button.${path}`}
                        trackingLabel={`Edit for ${title}`}
                        variant="tertiary"
                        icon={faPen}
                        iconAlign="left"
                        style={{ margin: 0, padding: 0 }}
                        handleClick={handleClick}
                    >
                        Edit
                    </Button>
                </div>
            </div>
            <Separator type="horizontal" noSpacing className={classes.separator} />
            <div className={classes.contentContainer}>
                {children}
            </div>
        </Card>
    );
};

_QuoteCard.propTypes = {
    title: PropTypes.string,
    path: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]),
    onEditClick: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({

    showPleaseWait: (value) => {
        dispatch({ type: 'SET_PAGE_VALUE', identifier: 'showPleaseWaitConfirmation', value });
    }

});

const QuoteCard = connect(null, mapDispatchToProps)(_QuoteCard);

export { _QuoteCard, QuoteCard };
